export const variables = {
  
  // API_URL: "https://localhost:44366/api/",
  API_URL: "https://eng-roster-backend-azapp-72-qa.azurewebsites.net/api/",
   
}